import SkTechApiClient from "./base/SkTechApiClient";
import dayjs, { Dayjs } from "dayjs";

export type Salary = {
  id: string;
  salaryPerHour: number;
  startDate: Dayjs;
  endDate: Dayjs;
  userId: string;
};

export default class SalaryApiClient extends SkTechApiClient {
  public getAll = async () => {
    return await this.Get(`/api/Salary`)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };
  public GetCurrentSalaries = async () => {
    return await this.Get(`/api/Salary/AllCurrentSalaries`)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };
  public salariesByPeriod = async (startDate: any, endDate: any) => {
    return await this.Get(
      `/api/Salary/GetByPeriod?startDate=${startDate}&endDate=${endDate}`
    )
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      })
      .catch(function (error) {
        console.log(error);
        return [];
      });
  };
  public addSalary = async (value: any) => {
    return await this.Post(`/api/Salary`, value)
      .then((response) => {
        if (response.status === 200) {
          return response.statusText;
        }
        return response.statusText;
      })
      .catch(function (error) {
        return error.response.data;
      });
  };
  public DeleteSalary = async (salaryId: any) => {
    return await this.Delete(`/api/Salary?id=${salaryId}`)
      .then((response) => {
        if (response.status === 200) {
          return true;
        }
        return false;
      })
      .catch(function (error) {
        console.log(error);
        return false;
      });
  };
  public UpdateSalary = async (salaryId: any, value: any) => {
    return await this.Put(`/api/Salary?id=${salaryId}`, value)
      .then((response) => {
        if (response.status === 200) {
          return response.statusText;
        }
        return response.statusText;
      })
      .catch(function (error) {
        return error.response.data;
      });
  };
}
